/**
 * Session context and types.
 *
 * Split from the provider so that neither file exports both a component and a
 * non-component — React Fast Refresh cannot hot-swap a module that does, and
 * losing HMR across the whole auth layer is a real cost over a five-week build.
 */
import { createContext } from 'react'

import type { Me } from '@/shared/api/types'

import type { Role } from './roles'

export type Session = {
  /**
   * `loading` is a real state, not a detail. Deciding anything before `/me/`
   * answers means either flashing a login screen at a signed-in user or the
   * reverse.
   */
  status: 'loading' | 'authenticated' | 'anonymous'
  /** The `/me/` payload, unmapped. Generated, so it cannot drift from the API. */
  user: Me | null
  /**
   * Whether the user holds a role *somewhere*. Scopes are deliberately not sent
   * to the browser (§3.4), so this can only decide what to render — never what
   * is allowed.
   */
  hasRole: (role: Role) => boolean
  /** Email or phone confirmed — the gate on uploading and enrolling (§8.1). */
  isVerified: boolean
  /** Re-read `/me/`, e.g. after finishing onboarding. */
  refresh: () => Promise<void>
}

export const SessionContext = createContext<Session | null>(null)
